import { gql } from '@apollo/client';

const schema = {
  current: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query product($ids: [String]) {
        product(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
